<template>
  <v-flex xs12>
    <v-col md12 class="mt-2 mb-1">
      <v-row>
        <v-col>
          <v-layout mb-3>
            <v-flex xs12>
              <img
                :src="templateConfig.logo"
                class="logo"
                width="225"
                height="50"
                alt="Logo"
              />
            </v-flex>
          </v-layout>

          <v-layout>
            <v-flex xs12 class="mb-2 cardHeader">
              <div
                v-if="merchantConfig.texts.topCardHeader"
                v-html="merchantConfig.texts.topCardHeader"
                class="topCardHeader"
              ></div>

              <div class="bottomCardHeader">
                <span
                  v-if="firstBottomCardHeaderText"
                  v-html="firstBottomCardHeaderText"
                  class="firstBottomCardHeader"
                >
                </span>
                <span
                  v-if="secondBottomCardHeaderText"
                  v-html="secondBottomCardHeaderText"
                  class="secondBottomCardHeader"
                  :class="templateConfig.isRtl ? 'pr-2' : 'pl-2'"
                >
                </span>
              </div>
            </v-flex>
          </v-layout>
        </v-col>
      </v-row>
    </v-col>
  </v-flex>
</template>

<script>
import { mapState } from 'vuex';
export default {
  props: {
    initialProductName: {
      default: null,
    },
    initialProductPrice: {
      default: null,
    },
    currency: {
      default: null,
    },
  },
  computed: {
    ...mapState(['templateConfig', 'merchantConfig']),
    firstBottomCardHeaderText() {
      return this.$replacePlaceholders(
        this.merchantConfig.texts.firstBottomCardHeader,
        {
          productName: this.initialProductName,
        }
      );
    },

    secondBottomCardHeaderText() {
      return this.$replacePlaceholders(
        this.merchantConfig.texts.secondBottomCardHeader,
        {
          price: this.initialProductPrice,
          currency: this.currency,
        }
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.logo {
  max-height: 50px;
  max-width: 225px;
}
.cardHeader {
  line-height: normal;
  .topCardHeader {
    font-size: 14px;
  }

  .bottomCardHeader {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    margin-top: 8px;
    .firstBottomCardHeader {
      font-size: 23px;
      font-weight: bold;
    }
    .secondBottomCardHeader {
      font-size: 14px;
    }
  }
}
</style>
